// extracted by mini-css-extract-plugin
module.exports = {"root":"kNCzp","freeItemsWrapper":"_3cB3M","title":"_1QHBr","subtitle":"_222WJ","items":"_17RKQ","item":"_24EqA"};